import { Button, Form } from 'react-bootstrap'
import KButton from '../../components/KButton'
import { t } from '../../locale'

type SortKey = 'name' | 'clientNumber' | 'country' | 'lastCheck'
type SortDir = 'asc' | 'desc'

interface ClientToolbarProps {
  searchKeyword: string
  onSearchChange: (value: string) => void
  onShowAll: () => void
  onFilterIsPerson: (value: string) => void
  onRiskFilter: (value: boolean | null | number, risk: 'kyc' | 'country') => void
  sortKey: SortKey
  sortDir: SortDir
  onSortChange: (key: SortKey, dir: SortDir) => void
  onViewChange: (isTable: boolean) => void
}

function ClientToolbar({
  searchKeyword,
  onSearchChange,
  onShowAll,
  onFilterIsPerson,
  onRiskFilter,
  sortKey,
  sortDir,
  onSortChange,
  onViewChange,
}: ClientToolbarProps) {
  return (
    <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3'>
      <input
        type='search'
        size={25}
        className='border px-2'
        placeholder={t('search') + '...'}
        aria-label='Search'
        value={searchKeyword}
        autoComplete='on'
        onChange={e => onSearchChange(e.target.value)}
      />
      <div className='btn-toolbar mb-2 mb-md-0 ms-4 flex-nowrap' style={{ gap: '8px' }}>
        {/* <Button variant='outline-primary' onClick={onShowAll}>
          {t('all')}
        </Button> */}
        <KButton
          variant='outline-primary'
          type='button'
          icon='person-fill'
          className='ms-3'
          title={t('naturalPerson')}
          onClick={() => onFilterIsPerson('yes')}
        />
        <KButton
          variant='outline-primary'
          type='button'
          icon='building-fill'
          title={t('company')}
          onClick={() => onFilterIsPerson('no')}
        />

        <KButton
          id='riskFilterNotTested'
          variant='outline-secondary'
          type='button'
          icon='star-fill'
          className='ms-3'
          title={t('notTested')}
          onClick={() => onRiskFilter(null, 'kyc')}
        />
        <KButton
          id='riskFilterSuccess'
          variant='outline-success'
          type='button'
          icon='star-fill'
          title={t('success')}
          onClick={() => onRiskFilter(false, 'kyc')}
        />
        <KButton
          id='countryFilter'
          variant='outline-warning'
          type='button'
          icon='star-fill'
          title={t('warning')}
          onClick={() => onRiskFilter(2, 'country')}
        />
        <KButton
          id='riskFilterDanger'
          variant='outline-danger'
          type='button'
          icon='star-fill'
          title={t('danger')}
          onClick={() => onRiskFilter(true, 'kyc')}
        />
        <Form.Select
          value={`${sortKey}:${sortDir}`}
          onChange={(e: any) => {
            const [k, d] = e.target.value.split(':') as [SortKey, SortDir]
            onSortChange(k, d)
          }}
          className='ms-3 text-decoration-none'
          style={{ width: 'auto', textTransform: 'none' }}
        >
          <option style={{ textTransform: 'none' }} value='name:asc'>
            {t('sortByName') + ' (A–Z)'}
          </option>
          <option style={{ textTransform: 'none' }} value='name:desc'>
            {t('sortByName') + ' (Z–A)'}
          </option>
          <option style={{ textTransform: 'none' }} value='clientNumber:asc'>
            {t('sortByClientNumber') + ' (' + t('asc') + ')'}
          </option>
          <option style={{ textTransform: 'none' }} value='clientNumber:desc'>
            {t('sortByClientNumber') + ' (' + t('desc') + ')'}
          </option>
          <option style={{ textTransform: 'none' }} value='country:asc'>
            {t('sortByCountry') + ' (A–Z)'}
          </option>
          <option style={{ textTransform: 'none' }} value='country:desc'>
            {t('sortByCountry') + ' (Z–A)'}
          </option>
          <option style={{ textTransform: 'none' }} value='lastCheck:desc'>
            {t('sortByLastCheck') + ' (' + t('newest') + ')'}
          </option>
          <option style={{ textTransform: 'none' }} value='lastCheck:asc'>
            {t('sortByLastCheck') + ' (' + t('oldest') + ')'}
          </option>
        </Form.Select>
        <Button
          variant='none'
          className='ms-2 btn-sm btn-icon-hover'
          onClick={() => onViewChange(false)}
        >
          <i className='bi bi-list-ul'></i>
        </Button>
        <Button
          variant='none'
          className='ms-2 btn-sm btn-icon-hover'
          onClick={() => onViewChange(true)}
        >
          <i className='bi bi-grid'></i>
        </Button>
      </div>
    </div>
  )
}

export default ClientToolbar
